"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
//
// Constants
//
const CIRCLE = 6;
const SPACE_X = 8;
const SPACE_Y = 8;
const COLORS = [
    '#CECDCC',
    '#fac940',
    '#f4d58a',
    '#c3dcf0',
    '#85c5fa',
    '#1787e5', // Very high
];
function rank_color(r) {
    if (r === -1)
        return '#515051';
    r = Math.min(Math.max(0, r), 5);
    return COLORS[r];
}
function cx(x) {
    return (CIRCLE / 2) + x * (SPACE_X + CIRCLE);
}
function cy(y) {
    return (CIRCLE / 2) + y * (SPACE_Y + CIRCLE);
}
class Circle {
    constructor(i, j, rank) {
        this.cx = cx(i);
        this.cy = cy(j);
        this.r = CIRCLE / 2;
        this.fill = rank_color(rank);
    }
    ;
}
let SvgSummary = class SvgSummary extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.circles = [];
        this.g_transform_obj = { scale: 1, x: 0, y: 0 };
    }
    get g_transform() {
        const obj = this.g_transform_obj;
        return `scale(${obj.scale}) translate(${obj.x} ${obj.y})`;
    }
    mounted() {
        const r = this.sample.becrop_report;
        const shi = this.sample.becrop_report_shi;
        let shi_rank = -1;
        if (shi) {
            shi_rank = shi.rank;
        }
        [
            [shi_rank, r.biodiversity_rank, r.functionality_rank, r.resistance_rank],
            [r.healthiness_rank, r.biocontrol_rank, r.hormoneprod_rank, r.stressadapt_rank],
            [r.nutrition_c_rank, r.nutrition_n_rank, r.nutrition_p_rank, r.nutrition_k_rank],
        ].forEach((row, j) => {
            row.forEach((rank, i) => {
                this.circles.push(new Circle(i, j, rank));
            });
        });
        const CANVAS_WIDTH = cx(4) - (CIRCLE / 2 + SPACE_X);
        const CANVAS_HEIGHT = cy(3) - (CIRCLE / 2 + SPACE_Y);
        const x_scale = this.width / CANVAS_WIDTH;
        const y_scale = this.height / CANVAS_HEIGHT;
        const scale = Math.min(x_scale, y_scale);
        this.g_transform_obj.scale = scale;
        const obj_w = CANVAS_WIDTH * scale;
        const obj_h = CANVAS_HEIGHT * scale;
        this.g_transform_obj.x = ((this.width - obj_w) / scale) / 2;
        this.g_transform_obj.y = ((this.height - obj_h) / scale) / 2;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 100 })
], SvgSummary.prototype, "width", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 20 })
], SvgSummary.prototype, "height", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SvgSummary.prototype, "sample", void 0);
SvgSummary = __decorate([
    (0, vue_property_decorator_1.Options)({})
], SvgSummary);
exports.default = SvgSummary;
